'use strict';
// @flow

export default class BorderController {
  $state;
  $scope;
  canvas;

  /*@ngInject*/
  constructor($state, $scope, Canvas) {
    this.$state = $state;
    this.$scope = $scope;
    this.canvas = Canvas;
  }

  $onInit = () => {
    this.$scope.borderTypes = [
      {
        type: 'none',
        name: 'none',
        radius: 0
      },
      {
        type: 'rect',
        name: 'miter',
        radius: 0
      },
      {
        type: 'round',
        name: 'round-small',
        radius: 10
      }
    ];
    this.$scope.bindingModel = this.canvas.getStageConfig();
    this.$scope.modelBinding = {
      radius: this.$scope.bindingModel.borderRadius,
      width: this.$scope.bindingModel.borderWidth
    };
  };

  onBorderTypeChanged = (type) => {
    this.canvas.setPreviewImagesBorderType(type.type, type.radius);
  };

  onBorderColorChanged = (hsb, hex, rgb) => {
    this.canvas.setPreviewImagesBorderColor('#' + hex);
  };

  onBorderWidthChanged = () => {
    this.canvas.setPreviewImagesBorderWith(this.$scope.modelBinding.width);
  };

  onBorderRadiusChanged = () => {
    this.canvas.setPreviewImagesBorderRadius(this.$scope.modelBinding.radius);
  };
}



// WEBPACK FOOTER //
// ./client/app/configurator/border/border.controller.js